import type { FC } from 'react';

import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';

interface HistoryControlPlainProps {
  condition: boolean;
  onClick: () => void;
}

export const HistoryControlPlain: FC<HistoryControlPlainProps> = ({ condition, onClick }) => {
  return (
    <IconButtonWithTooltip
      data-testid="history-button"
      icon={Icons.History}
      active={condition}
      onClick={onClick}
      tooltipOptions={{
        text: 'HISTORY',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
